import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {isEmpty} from "../../../components/commonmethod/CommonMethod";
import {
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailFormPageShell,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import Th_title from "../../../components/Th_title";
import {useDispatch, useSelector} from "react-redux";
import {apiLoading, skeleton} from "../../../redux/slice/apiSlice";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import dayjs from "dayjs";
import SimmsInput from "../../../components/input/SimmsInput";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../components/selector/Selector";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import {handleActiveError} from "../../../components/sonner/ToastBasic";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import {CodeSpecNum} from "../../../constant/CodeSpecNum";
import {saveDispose} from "../../../api/lifecycle/dispose/DisposeService";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../components/selection/UserSelectionField";

function DisposeCreate() {
    const formatDate = (date) => {
        const year = String(date.getFullYear()).slice(2); // 연도 마지막 두 자리
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 월 (0부터 시작하므로 +1 필요)
        const day = String(date.getDate()).padStart(2, '0'); // 일

        return `${year}${month}${day}`;
    };

    const user = useSelector(state => state.auth.user);
    const [dispose, setDispose] = useState({number : formatDate(new Date()), requester : user});
    const [assets, setAssets] = useState([]);
    const [docs, setDocs] = useState([]);

    const location = useLocation();
    const navigate = useNavigate();
    const cancel = {
        url: "/lifecycle/dispose"
    }

    const requireds =["name","requester", "inspector", "requestCode", "requestStartDate", "requestEndDate"]
    const dispatch = useDispatch();
    const create = async () => {

        if(assets.length == 0){
            alert("폐기자산을 선택해주세요")
            return false;
        }

        if(requireds.some(e=> isEmpty(dispose[e]))){
            alert("필수값이 누락되었습니다.")
            return
        }

        dispatch(apiLoading(true));

        const docFile = []
        docs.forEach(each => docFile.push(each.object))

        const assetData = assets?.map(item => ({asset : {id : item.id}}));
        dispose.assets = assetData;

        const updatedData = {
            ...dispose,
            requester: {id: dispose.requester.id},
            inspector: {id: dispose.inspector.id},
            requestCode: {id: dispose.requestCode.id},
        }

        await saveDispose(updatedData, docFile).then(response => {
            if (response.status === 200) {
                alert("등록되었습니다.")
                navigate("/lifecycle/dispose", {
                    state: {
                        test: location.state
                    }
                });
            }else if (response.status === 201 || (response.status === 202)) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if(response.status===413){
                handleActiveError({message: "첨부파일 용량이 너무 큽니다."});
            }else{
                handleActiveError({message: "등록에 실패하였습니다."});
            }
        }).finally(dispatch(apiLoading(false)));
    }

    useEffect(() => {
        dispatch(skeleton(false))
    }, [])

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="자산폐기 등록"
            meta="신규 폐기 요청 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/lifecycle/dispose")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailThreeColLayout
                        primary={
                            <>
            <DetailPanel title="폐기자산">
                <DetailKvTable>
                    <tbody>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top" required auth>
                            <UserSelectionField
                                layout="inline"
                                data={assets}
                                countUnit="개"
                                chipEntity="asset"
                                listModalTitle="자산목록"
                                onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                            >
                                <SearchSelector
                                    auth
                                    multiSelect
                                    variant="compact"
                                    entity="dispose"
                                    uniqueKey="assets"
                                    data={assets}
                                    onChange={(v) => {
                                        if (v?.__multiFlat) setAssets(v.__multiFlat);
                                    }}
                                >
                                    <SimmsInputSearch type="TEXT"/>
                                    <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive/>
                                    <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive/>
                                    <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive/>
                                    <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator"/>
                                    <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler"/>
                                </SearchSelector>
                            </UserSelectionField>
                        </Th_title>
                    </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>

            <DetailPanel title="요청정보">
                <DetailKvTable>
                    <tbody>
                        <tr>
                            <Th_title title={"요청자"} colspan={3} className="fieldset-td" required auth>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setDispose, "requester", dispose.requester ,v)}
                                    data={dispose.requester}
                                    entity={"userAccount"}
                                    uniqueKey={'requester'}>
                                    <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                    <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                    <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                                </Selector>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"요청종류"} colspan={3} className="fieldset-td" required auth>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setDispose, "requestCode", dispose.requestCode ,v)}
                                    data={dispose.requestCode}
                                    entity={"code"}
                                    parentKey={CodeSpecNum.DisposeRequestCode}
                                    recursive
                                />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"요청일"} colspan={3} className="fieldset-td fieldset-td-input" required auth>
                                <div className="web-flex asset-detail-date-range">
                                    <SimmsDatePicker
                                        onChange={(v)=>dateOnChange(setDispose,"requestStartDate", v, false)}
                                        data={dispose.requestStartDate}
                                        constraint={{lessThan : dispose.requestEndDate && dayjs(dispose.requestEndDate), required: true}} auth />
                                    <span className="asset-detail-date-range-sep">~</span>
                                    <SimmsDatePicker
                                        onChange={(v)=>dateOnChange(setDispose,"requestEndDate", v, false)}
                                        data={dispose.requestEndDate}
                                        constraint={{largerThan : dispose.requestStartDate && dayjs(dispose.requestStartDate), required: true}} auth />
                                </div>
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
                            </>
                        }
                        secondary={
            <DetailPanel title="요청내용">
                <DetailKvTable>
                    <tbody>
                        <tr>
                            <Th_title title={"요청번호"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"number"} value={dispose.number} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"검수자"} colspan={3} className="fieldset-td" auth required>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setDispose, "inspector", dispose.inspector ,v)}
                                    data={dispose.inspector}
                                    entity={"userAccount"}
                                    uniqueKey={'inspector'}>
                                    <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                    <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                    <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                                </Selector>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"제목"} colspan={3} className="fieldset-td" auth required>
                                <SimmsInput onChange={(v)=>inputOnChange(setDispose,"name", v, true)} data={dispose.name} style={{width: "100%"}} />
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"내용"} colspan={3} className="fieldset-td" auth>
                                <SimmsTextArea onChange={(v)=>inputOnChange(setDispose,"content", v, false)}
                                               style={{width: "100%", minHeight: "80px"}}
                                               data={dispose.content} />
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"기타"} colspan={3} className="fieldset-td" auth>
                                <SimmsTextArea onChange={(v)=>inputOnChange(setDispose,"etc", v, false)}
                                               style={{width: "100%", minHeight: "80px"}}
                                               data={dispose.etc} />
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
                        }
                        aside={
                            <DetailFilePanel
                                title="첨부"
                                isEditing
                                pendingFiles={{files: docs, setFiles: setDocs}}
                                pendingInputId="dispose_create_doc"
                            />
                        }
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {DisposeCreate}